/**
 * Calculates the width of the container based on the available space and padding.
 * @returns {number} The calculated width in pixels.
 */
export const calc = (value: number | number[]) => `calc( 100% - ${value}px )`
